import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1653656804717'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='5117'
    >
        <path
            d='M512 1023.999078a510.371381 510.371381 0 1 1 199.290701-40.232923A508.763702 508.763702 0 0 1 512 1023.999078zM348.057748 726.609266v39.045085h445.439599a77.107131 77.107131 0 0 0 54.96827-22.79422l21.97502-21.90334-27.545575-27.566055-21.91358 21.8419a38.574045 38.574045 0 0 1-27.453415 11.37663h-445.439599zM153.600323 355.8704l39.137244 136.662917 156.08818 0.13312 94.504875 157.337458a78.520249 78.520249 0 0 0 66.9593 37.887966H757.759779a78.12089 78.12089 0 0 0 66.88762-118.486933l-10.956791-18.247664-71.024576-118.189974a78.510009 78.510009 0 0 0-66.959299-37.887966H236.656888l-24.463338-39.198684z m371.087026-58.480588v68.341699h39.045084v-68.341699h234.28075v-39.045085H270.837977v39.045085z m229.723953 231.188272H570.562507v-94.207915h110.827421a42.096602 42.096602 0 0 1 33.19805 20.254702l44.22652 73.727933z'
            p-id='5118'
            fill='currentColor'
        ></path>
    </svg>
)

export const HelicopterIcon = props => <Icon component={SVG} {...props} />
